/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiAdminDtoRecentLogDto } from './WebApiAdminDtoRecentLogDto';
import {
    WebApiAdminDtoRecentLogDtoFromJSON,
    WebApiAdminDtoRecentLogDtoFromJSONTyped,
    WebApiAdminDtoRecentLogDtoToJSON,
} from './WebApiAdminDtoRecentLogDto';

/**
 * Errors and issues summary
 * @export
 * @interface WebApiAdminDtoErrorsSummaryDto
 */
export interface WebApiAdminDtoErrorsSummaryDto {
    /**
     * Number of errors logged today
     * @type {number}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    errorCountToday?: number;
    /**
     * Number of warnings logged today
     * @type {number}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    warningCountToday?: number;
    /**
     * Number of errors logged this week
     * @type {number}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    errorCountThisWeek?: number;
    /**
     * Number of warnings logged this week
     * @type {number}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    warningCountThisWeek?: number;
    /**
     * Recent error log entries
     * @type {Array<WebApiAdminDtoRecentLogDto>}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    recentErrors?: Array<WebApiAdminDtoRecentLogDto> | null;
    /**
     * Recent warning log entries
     * @type {Array<WebApiAdminDtoRecentLogDto>}
     * @memberof WebApiAdminDtoErrorsSummaryDto
     */
    recentWarnings?: Array<WebApiAdminDtoRecentLogDto> | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoErrorsSummaryDto interface.
 */
export function instanceOfWebApiAdminDtoErrorsSummaryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoErrorsSummaryDtoFromJSON(json: any): WebApiAdminDtoErrorsSummaryDto {
    return WebApiAdminDtoErrorsSummaryDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoErrorsSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoErrorsSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorCountToday': !exists(json, 'errorCountToday') ? undefined : json['errorCountToday'],
        'warningCountToday': !exists(json, 'warningCountToday') ? undefined : json['warningCountToday'],
        'errorCountThisWeek': !exists(json, 'errorCountThisWeek') ? undefined : json['errorCountThisWeek'],
        'warningCountThisWeek': !exists(json, 'warningCountThisWeek') ? undefined : json['warningCountThisWeek'],
        'recentErrors': !exists(json, 'recentErrors') ? undefined : (json['recentErrors'] === null ? null : (json['recentErrors'] as Array<any>).map(WebApiAdminDtoRecentLogDtoFromJSON)),
        'recentWarnings': !exists(json, 'recentWarnings') ? undefined : (json['recentWarnings'] === null ? null : (json['recentWarnings'] as Array<any>).map(WebApiAdminDtoRecentLogDtoFromJSON)),
    };
}

export function WebApiAdminDtoErrorsSummaryDtoToJSON(value?: WebApiAdminDtoErrorsSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorCountToday': value.errorCountToday,
        'warningCountToday': value.warningCountToday,
        'errorCountThisWeek': value.errorCountThisWeek,
        'warningCountThisWeek': value.warningCountThisWeek,
        'recentErrors': value.recentErrors === undefined ? undefined : (value.recentErrors === null ? null : (value.recentErrors as Array<any>).map(WebApiAdminDtoRecentLogDtoToJSON)),
        'recentWarnings': value.recentWarnings === undefined ? undefined : (value.recentWarnings === null ? null : (value.recentWarnings as Array<any>).map(WebApiAdminDtoRecentLogDtoToJSON)),
    };
}

